export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            原创漫画作者投稿、商务合作、版权洽谈或任何关于尾巴漫画的问题，
            欢迎通过以下方式与我们联系，我们会在第一时间回复您。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
            <div className="flex items-center gap-3 px-5 py-3 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿与合作</div>
                <div className="text-sm font-medium text-foreground-950">contact@weibamanga.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3 px-5 py-3 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500">
                <i className="ri-customer-service-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">客服支持</div>
                <div className="text-sm font-medium text-foreground-950">support@weibamanga.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3 px-5 py-3 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500">
                <i className="ri-brush-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">作者入驻</div>
                <div className="text-sm font-medium text-foreground-950">author@weibamanga.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}